// (c) 2020, SAS Institute Inc.

import axios from './Axios';
export * from './Axios';
export * from './HeaderName';
export default axios;
export { AxiosHeaders } from 'axios';
export { isAxiosError } from 'axios';
export { getAdapter } from 'axios';
export { isCancel } from 'axios';
export { toFormData } from 'axios';
export { formToJSON } from 'axios';
//# sourceMappingURL=index.js.map